import React, { FunctionComponent } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

type MarkdownProps = {
    source: string;
};

export const Markdown: FunctionComponent<
    React.PropsWithChildren<MarkdownProps>
> = ({ source }) => (
    <ReactMarkdown rehypePlugins={[rehypeRaw]}>{source}</ReactMarkdown>
);
